import { Box } from 'braid-design-system';
import { FilterSideBar } from 'src/components/app/FilterSideBar/FilterSideBar';
import * as styles from './styles.css';
import type { FilterFns } from 'src/components/app/FilterSideBar/useFilters';
import type { FC, ReactNode } from 'react';

interface FilterDesktopProps {
  selectedFilterCount: number;
  isStickyOnDesktop: boolean;
  filters: ReactNode;
  resetFilters: FilterFns['resetFilters'];
}

export const FilterDesktop: FC<FilterDesktopProps> = ({
  isStickyOnDesktop,
  filters,
  selectedFilterCount,
  resetFilters,
}) => (
  <Box
    paddingBottom="medium"
    className={{
      [styles.sticky]: true,
      [styles.stickyBelowTab]: isStickyOnDesktop,
      [styles.sideBarBorder]: true,
    }}
  >
    <Box className={[styles.hideOnTablet]}>
      <Box
        className={styles.filterSideBar}
        onScroll={(event: any) => {
          const target = event?.nativeEvent?.target;
          if (target) {
            const { top } = target.getBoundingClientRect();

            if (top > 0) {
              target.scrollIntoView({ behavior: 'smooth' });
            }
          }
        }}
      >
        <FilterSideBar
          selectedFilterCount={selectedFilterCount}
          resetFilters={resetFilters}
          filters={filters}
        />
      </Box>
    </Box>
  </Box>
);
